import { render, staticRenderFns } from "./ermjTable.vue?vue&type=template&id=49b11d78&scoped=true"
import script from "./ermjTable.vue?vue&type=script&lang=ts"
export * from "./ermjTable.vue?vue&type=script&lang=ts"
import style0 from "./ermjTable.vue?vue&type=style&index=0&id=49b11d78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b11d78",
  null
  
)

export default component.exports